export const filterBank = state => state.bank.filter;
export const bankStatisticDefault = state => state.bank.bankStatisticData;
export const bankTransactionDefault = state => state.bank.bankTransactionData;
export const currentTransaction = state => state.bank.currentTransaction;
export const bankDataSuccess = state => state.bank.fetchBankDataSuccess;
export const bankStatisticData = state => state.bank.bankStatisticData;
